import { SketchToolDrawer as View } from "ui-components";

import { useCloseMapTool } from "~map-view/states";
import {
	useActive,
	useSetDrawingMode,
	useSetSketchGeojson,
} from "~map-view/states/sketch";
import { Sketches } from "~map-view/views/map-view/drawer-content/sketch/sketches";
import { SketchEditor } from "~map-view/views/map-view/drawer-content/sketch/sketchEditor";
import { SketchCreate } from "~map-view/views/map-view/drawer-content/sketch/sketchCreate";
import { SketchView } from "~map-view/views/map-view/drawer-content/sketch/sketchView";
import { LineEditor } from "~map-view/views/map-view/drawer-content/sketch/sketchEditor/lineEditor";
import { PolygonEditor } from "~map-view/views/map-view/drawer-content/sketch/sketchEditor/polygonEditor";
import { MarkerEditor } from "~map-view/views/map-view/drawer-content/sketch/sketchEditor/markerEditor";
import { TextAnnotationEditor } from "~map-view/views/map-view/drawer-content/sketch/sketchEditor/textAnnotationEditor";
import { useSketchTitle } from "~map-view/hooks/useSketchTitle";
import { useDrawEditor } from "~map-view/views/map-view/drawer-content/sketch/drawEditor";

export const SketchToolDrawer = () => {
	const setSketchGeojson = useSetSketchGeojson();
	const setDrawingMode = useSetDrawingMode();
	const closeMapTool = useCloseMapTool();
	const title = useSketchTitle();
	const active = useActive();
	useDrawEditor();

	const handleClose = () => {
		setDrawingMode("close");
		setSketchGeojson(null);
		setTimeout(() => {
			closeMapTool();
		});
	};
	return (
		<View
			onClose={handleClose}
			title={title}
			slots={{
				Sketches,
				SketchEditor,
				SketchCreate,
				SketchView,
				LineEditor,
				PolygonEditor,
				MarkerEditor,
				TextAnnotationEditor,
			}}
			slotProps={{
				active,
			}}
		/>
	);
};
